module.exports = __webpack_public_path__ + "img/2022_1.ebcad333.webp";